<dialog-draggable-header>User Maintenance</dialog-draggable-header>

<div #content mat-dialog-content>
   <data-table [data]="usersData" [columns]="columns" [filterColumnDisplay]="false" [paging]="true" 
      [pageSize]="this.pageOptions.size" [totalRecords]="total" [lazy]="true" (lazyLoad)="onLazyLoad($event)"
      [loading]="loading" (select)="onSelect($event)" (edit)="updateUser($event)" [showAllPaging]="false">
      <ng-container actionStart>
         <button mat-button (click)="onAddUserClick()">Add User</button>
         <mat-divider vertical class="action-bar-vertical-divider"></mat-divider>
         <button mat-button (click)="onReportClick()">Report (xls)</button>
         <mat-divider vertical class="action-bar-vertical-divider"></mat-divider>
         <button mat-button (click)="emailUserHandler()">Email User</button>
         <mat-divider vertical class="action-bar-vertical-divider"></mat-divider>
         <button mat-button (click)="onManageRequestAccessClick()"
            (keypress.enter)="onManageRequestAccessClick()">Manage Request Access</button>
         <mat-form-field class="spacerLeft">
            <input #searchBar id="search-user-id" type="text" matInput (keydown.enter)="searchByUser(searchBar)"
               [(ngModel)]="searchBarInput" placeholder="Search Last Name" />
            <span *ngIf="searchBarInput" style="margin-left:-20px;">
               <a (click)="clearSearch()">
                  <i class="fa fa-times" style="color: rgb(149, 149, 153); cursor: pointer;"></i>
               </a>
            </span>
            <button mat-icon-button matSuffix (click)="searchByUser(searchBar)"
               (keydown.enter)="searchByUser(searchBar)">
               <mat-icon matSuffix>search</mat-icon>
            </button>
         </mat-form-field>
      </ng-container>
      <ng-container actionEnd>
         <button mat-dialog-close mat-button> Close </button>
      </ng-container>
   </data-table>
</div>